
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
// import BackToTop from "../components/BackToTop";
// import PageHeader from "../components/PageHeader";
// import "../css/event.css"; 

// // ✅ Import Event 1 images
// import event1_1 from "../assets/event/Event1/event1-1.jpeg";
// import event1_2 from "../assets/event/Event1/event1-2.jpeg";
// import event1_3 from "../assets/event/Event1/event1-3.jpeg";

// // ✅ Import Event 2 images
// import event2_1 from "../assets/event/Event2/event2-1.jpeg";
// import event2_2 from "../assets/event/Event2/event2-2.jpeg";
// import event2_3 from "../assets/event/Event2/event2-3.jpeg";

// export default function Events() {
//   return (
//     <>
//       <Navbar />
//       <PageHeader title="Flagship Events" path="/event" name="Events" />

//       <div className="events-page">
//         {/* ---------- EVENT 1 ---------- */}
//         <div className="event-card fade-in">
//           <div className="event-text">
//             <h3>Event 1 — Honorary Doctorate Recognition</h3>
//             <p className="event-date">Date: 14 November 2025</p>
//             <p>
//               Our Honorable President and Founder, <b>Sri Subhradeep Chowdhury</b>,
//               received the <b>Honorary Doctorate</b> from the <b>World Culture & Environment Protection Commission</b> at Radisson Blu Hotel, Delhi, for his exceptional work in human rights and social justice.
//             </p>
//             <p>
//               This honour represents not just an individual achievement but a
//               recognition of every struggle, every voice that demanded justice,
//               and every act of compassion in service of humanity.
//             </p>
//             <p>
//               We express heartfelt gratitude to the Commission and to all
//               supporters who have stood beside us. Together, we reaffirm our
//               mission to raise our voices for the voiceless and stand for
//               justice with courage and compassion.
//             </p>
//           </div>

//          <div className="event-gallery">
//             <img src={event1_1} alt="Event 1 - Honorary Doctorate" />
//             <img src={event1_2} alt="Event 1 - Ceremony" />
//             <img src={event1_3} alt="Event 1 - Team Celebration" />
//           </div>
//         </div>

//         {/* ---------- EVENT 2 ---------- */}
//         <div className="event-card fade-in">
//           <div className="event-text">
//             <h3>Event 2 — NGO Mahakumbh 3.0</h3>
//             <p className="event-date">Date: 20 December 2025</p>
//             <p>
//               The <b>National Human Rights Federation</b> was honored to be part of
//               <b> NGO Mahakumbh 3.0</b>, held at the prestigious Lemon Tree Hotel,
//               New Delhi. The event brought together over 500 of India’s leading NGOs
//               under one roof.
//             </p>
//             <p>
//               Our delegation, led by <b>President Subhradeep Chowdhury</b>, with{" "}
//               <b>Subhadeep Santra</b> and other members, actively participated in
//               discussions on human rights collaboration and development.
//             </p>
//             <p>
//               We held insightful interactions with <b>Rajesh Kumar Verma</b>,
//               world record holder, and plan to collaborate on impactful projects
//               including <b>organic food systems</b>, <b>Ayurveda-based healthcare</b>,
//               and the <b>revival of the Gurukul education model</b>. We’re optimistic
//               about securing <b>₹100 crore in funding</b> over the next five years,
//               strengthening our mission and reach.
//             </p>
//           </div>

//           <div className="event-gallery">
//             <img src={event2_1} alt="Event 2 - NGO Mahakumbh" />
//             <img src={event2_2} alt="Event 2 - Delegation" />
//             <img src={event2_3} alt="Event 2 - Collaboration" />
//           </div>
//         </div>
//       </div>

//       <Footer />
//       <BackToTop />
//     </>
//   );
// }

// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
// import BackToTop from "../components/BackToTop";
// import PageHeader from "../components/PageHeader";
// import "../css/event.css";

// // ✅ Import Event 1 images
// import event1_1 from "../assets/event/Event1/event1-1.jpeg";
// import event1_2 from "../assets/event/Event1/event1-2.jpeg";
// import event1_3 from "../assets/event/Event1/event1-3.jpeg";

// // ✅ Import Event 2 images
// import event2_1 from "../assets/event/Event2/event2-1.jpeg";
// import event2_2 from "../assets/event/Event2/event2-2.jpeg";
// import event2_3 from "../assets/event/Event2/event2-3.jpeg";

// export default function Events() {
//   return (
//     <>
//       <Navbar />
//       <PageHeader title="Flagship Events" path="/event" name="Events" />

//       <div className="events-page">

//         {/* ---------- EVENT 1 ---------- */}
//         <div className="event-card fade-in">
//           <div className="event-content left">
//             <div className="event-text">
//               <h3>🏅 Honorary Doctorate Recognition</h3>
//               <p className="event-date">📅 14 November 2025</p>
//               <p>
//                 Our Honorable President and Founder, <b>Sri Subhradeep Chowdhury</b>,
//                 received the <b>Honorary Doctorate</b> from the <b>World Culture & Environment Protection Commission</b> 
//                 at Radisson Blu Hotel, Delhi, for his exceptional work in human rights and social justice.
//               </p>
//               <p>
//                 This honour is not just a personal milestone—it is a recognition of every struggle, 
//                 every voice that demanded justice, and every act of compassion that strengthened humanity.
//               </p>
//               <p>
//                 We extend heartfelt gratitude to the Commission and our supporters who stand with us. 
//                 Together, we continue our mission to raise our voices for the voiceless and uphold justice with courage and empathy.
//               </p>
//             </div>

//             <div className="event-gallery">
//               <img src={event1_1} alt="Event 1 - Honorary Doctorate" />
//               <img src={event1_2} alt="Event 1 - Ceremony" />
//               <img src={event1_3} alt="Event 1 - Celebration" />
//             </div>
//           </div>
//         </div>

//         {/* ---------- EVENT 2 ---------- */}
//         <div className="event-card fade-in alt">
//           <div className="event-content right">
//             <div className="event-gallery">
//               <img src={event2_1} alt="Event 2 - NGO Mahakumbh" />
//               <img src={event2_2} alt="Event 2 - Delegation" />
//               <img src={event2_3} alt="Event 2 - Collaboration" />
//             </div>

//             <div className="event-text">
//               <h3>🤝 NGO Mahakumbh 3.0 — A Landmark Gathering</h3>
//               <p className="event-date">📅 20 December 2025</p>
//               <p>
//                 The <b>National Human Rights Federation</b> proudly participated in 
//                 <b> NGO Mahakumbh 3.0</b> at the prestigious Lemon Tree Hotel, New Delhi, 
//                 bringing together over <b>500 leading NGOs</b> from across India.
//               </p>
//               <p>
//                 Led by <b>President Subhradeep Chowdhury</b> and <b>Subhadeep Santra</b>, 
//                 our delegation engaged in meaningful discussions on advancing human rights collaboration and social initiatives.
//               </p>
//               <p>
//                 Notably, we forged partnerships with <b>Rajesh Kumar Verma</b>, a world record holder, 
//                 to collaborate on projects in <b>organic agriculture</b>, <b>Ayurveda healthcare</b>, and the 
//                 <b> Gurukul education revival model</b>. With an expected funding of <b>₹100 crore</b> over five years, 
//                 our mission grows stronger and more impactful.
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       <Footer />
//       <BackToTop />
//     </>
//   );
// }

import { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import PageHeader from "../components/PageHeader";
import "../css/event.css";

// ✅ Import Event 1 images
import event1_1 from "../assets/event/Event1/event1-1.jpeg";
import event1_2 from "../assets/event/Event1/event1-2.jpeg";
import event1_3 from "../assets/event/Event1/event1-3.jpeg";

// ✅ Import Event 2 images
import event2_1 from "../assets/event/Event2/event2-1.jpeg";
import event2_2 from "../assets/event/Event2/event2-2.jpeg";
import event2_3 from "../assets/event/Event2/event2-3.jpeg";

export default function Events() {
  const [previewImg, setPreviewImg] = useState(null);

  const openPreview = (imgSrc) => {
    setPreviewImg(imgSrc);
  };

  const closePreview = () => {
    setPreviewImg(null);
  };

  return (
    <>
      <Navbar />
      <PageHeader title="Flagship Events" path="/event" name="Events" />

      <div className="events-page">
        {/* ---------- EVENT 1 ---------- */}
        <div className="event-card fade-in">
          <div className="event-content left">
            <div className="event-text">
              <h3>🏅 Honorary Doctorate Recognition</h3>
              <p className="event-date">📅 14 November 2025</p>
              <p>
                Our Honorable President and Founder, <b>Sri Subhradeep Chowdhury</b>,
                received the <b>Honorary Doctorate</b> from the{" "}
                <b>World Culture & Environment Protection Commission</b> at
                Radisson Blu Hotel, Delhi, for his exceptional work in human
                rights and social justice.
              </p>
              <p>
                This honour is not just a personal milestone—it is a recognition
                of every struggle, every voice that demanded justice, and every
                act of compassion that strengthened humanity.
              </p>
              <p>
                We extend heartfelt gratitude to the Commission and our
                supporters who stand with us. Together, we continue our mission
                to raise our voices for the voiceless and uphold justice with
                courage and empathy.
              </p>
            </div>

            <div className="event-gallery">
              {[event1_1, event1_2, event1_3].map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`Event 1 image ${idx + 1}`}
                  onClick={() => openPreview(img)}
                />
              ))}
            </div>
          </div>
        </div>

        {/* ---------- EVENT 2 ---------- */}
        <div className="event-card fade-in">
          <div className="event-content left">
            <div className="event-gallery">
              {[event2_1, event2_2, event2_3].map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`Event 2 image ${idx + 1}`}
                  onClick={() => openPreview(img)}
                />
              ))}
            </div>

            <div className="event-text">
              <h3>🤝 NGO Mahakumbh 3.0 — A Landmark Gathering</h3>
              <p className="event-date">📅 20 December 2025</p>
              <p>
                The <b>National Human Rights Federation</b> proudly participated
                in <b>NGO Mahakumbh 3.0</b> at the prestigious Lemon Tree Hotel,
                New Delhi, bringing together over <b>500 leading NGOs</b> from
                across India.
              </p>
              <p>
                Led by <b>President Subhradeep Chowdhury</b> and{" "}
                <b>Subhadeep Santra</b>, our delegation engaged in meaningful
                discussions on advancing human rights collaboration and social
                initiatives.
              </p>
              <p>
                Notably, we forged partnerships with <b>Rajesh Kumar Verma</b>,
                a world record holder, to collaborate on projects in{" "}
                <b>organic agriculture</b>, <b>Ayurveda healthcare</b>, and the{" "}
                <b>Gurukul education revival model</b>. With an expected funding
                of <b>₹100 crore</b> over five years, our mission grows stronger
                and more impactful.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- IMAGE PREVIEW MODAL ---------- */}
      {previewImg && (
        <div className="image-preview-overlay" onClick={closePreview}>
          <img src={previewImg} alt="Full preview" className="preview-image" />
        </div>
      )}

      <Footer />
      <BackToTop />
    </>
  );
}
